import type { Assignment } from "./types";

export type AssignmentStatus =
  | "pending"        // creada pero todavía no se mandó email
  | "sent"           // email enviado, candidato no entró aún
  | "in_progress"    // candidato entró y empezó
  | "completed"      // candidato terminó normal
  | "invalidated"    // anti-cheat tripped
  | "timed_out"      // venció el countdown del test
  | "expired";       // expires_at pasó sin que entre

const STATUS_LABELS: Record<AssignmentStatus, string> = {
  pending: "Pendiente",
  sent: "Enviado",
  in_progress: "En curso",
  completed: "Completado",
  invalidated: "Invalidado",
  timed_out: "Tiempo agotado",
  expired: "Expirado",
};

const STATUS_VARIANTS: Record<
  AssignmentStatus,
  "muted" | "info" | "warning" | "success" | "danger" | "outline" | "default"
> = {
  pending: "muted",
  sent: "info",
  in_progress: "warning",
  completed: "success",
  invalidated: "danger",
  timed_out: "danger",
  expired: "outline",
};

export function deriveStatus(a: Assignment): AssignmentStatus {
  if (a.invalidated_at) return "invalidated";
  if (a.completed_at) return "completed";
  if (a.timed_out_at) return "timed_out";
  if (a.started_at) return "in_progress";
  if (a.expires_at && new Date(a.expires_at) < new Date()) return "expired";
  if (a.sent_email_at) return "sent";
  return "pending";
}

export function statusLabel(s: AssignmentStatus): string {
  return STATUS_LABELS[s];
}

export function statusVariant(s: AssignmentStatus) {
  return STATUS_VARIANTS[s];
}
